import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {workflow} from '../store/reducers/workflow';
import {
    changePatientContextTab,
    ctxCurrentTab,
    openPatientForm,
    setContextDialogTypeOpen,
    setObservationType,
} from '../store/reducers/patientContext';
import {WORKFLOW_OPTIONS} from '../util/workflowUtil';
import {PATIENT_CONTEXT_TABS_ID} from '../pages/ward/forms/formsUtil';

const useWorkflow = (patient) => {
    const dispatch = useDispatch();

    // Selectors
    const workflowData = useSelector(workflow);
    const currentTab = useSelector(ctxCurrentTab);

    // Handle workflow
    useEffect(() => {
        switch (workflowData.type) {
            // Opening forms
            case WORKFLOW_OPTIONS.SEPSIS:
            case WORKFLOW_OPTIONS.SAFEGUARDING:
            case WORKFLOW_OPTIONS.CLINICAL_FRAILTY_SCORE:
            case WORKFLOW_OPTIONS.SAFETY_CHECKLIST:
            case WORKFLOW_OPTIONS.CLINICAL_CONCLUSION:
            case WORKFLOW_OPTIONS.VERIFICATION_OF_DEATH:
                dispatch(openPatientForm(workflowData.type));
                break;

            // Sepsis pathway workflow
            case WORKFLOW_OPTIONS.SEPSIS_PATHWAY:
                dispatch(changePatientContextTab(PATIENT_CONTEXT_TABS_ID.SEPSIS, true));
                break;

            // Observation workflow
            case WORKFLOW_OPTIONS.NEURO_OBSERVATION:
                if (currentTab !== PATIENT_CONTEXT_TABS_ID.OBSERVATIONS) {
                    dispatch(changePatientContextTab(PATIENT_CONTEXT_TABS_ID.OBSERVATIONS, true));
                }
                dispatch(setObservationType('neuroObs'));
                dispatch(openPatientForm('neuroObs'));
                break;

            // S&R workflow
            case WORKFLOW_OPTIONS.STREAMING_AND_REDIRECTION:
                if (patient?.metadata?.snReferralId) {
                    dispatch(openPatientForm('referralReview'));
                } else {
                    console.warn('No referralId found in patient metadata');
                }
                break;

            // Warning modals open workflow
            case WORKFLOW_OPTIONS.OPEN_SAFEGUARDING_DIALOG:
            case WORKFLOW_OPTIONS.OPEN_CAUSE_FOR_CONCERN_DIALOG:
            case WORKFLOW_OPTIONS.OPEN_CFS_DIALOG:
            case WORKFLOW_OPTIONS.OPEN_MENTAL_HEALTH_DIALOG:
                dispatch(setContextDialogTypeOpen(workflowData.type));
                break;
            default:
                break;
        }
    }, [patient, workflowData, currentTab]);
};

export default useWorkflow;